import { Bell, Clock, Shield, Zap } from "lucide-react";
import SectionWrapper from "../components/SectionWrapper";
import IconCard from "../components/IconCard";
import { AnimatedHeading, AnimatedParagraph } from "../components/AnimatedText";

const Benefits = () => {
  const benefits = [
    {
      icon: <Bell className="w-8 h-8" />,
      title: "Reduce Disruptions",
      description: "The average user receives 100+ notifications per day. Sera reduces this noise by batching notifications and delivering them at times you choose."
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Custom Batch Schedules",
      description: "Schedule your batches to be delivered at times you choose that best fit your productivity and focus goals."
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Priority Apps Break Through",
      description: "Select which apps can break through your batching schedule to be delivered immediately."
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Privacy & Data Security",
      description: "All processing happens on your device. No data collection or ads. Your data never leaves your device."
    }
  ];

  return (
    <SectionWrapper id="benefits" padding="xl">
      <div className="text-center mb-16">
        <AnimatedHeading 
          as="h2" 
          className="text-4xl md:text-5xl mb-6"
        >
          Discover Sera's Benefits
        </AnimatedHeading>
        <AnimatedParagraph 
          className="text-xl max-w-3xl mx-auto"
          delay={0.2}
        >
          Unlock a world of focused productivity, intelligent batching, and seamless notification management.
        </AnimatedParagraph>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 items-stretch">
        {benefits.map((benefit, index) => (
          <IconCard
            key={index}
            icon={benefit.icon}
            title={benefit.title}
            description={benefit.description}
            delay={index * 0.1}
            titleClassName="text-xl font-semibold mb-4"
          />
        ))}
      </div>
    </SectionWrapper>
  );
};

export default Benefits;
